<script>

import _ from "lodash";
import axios from "axios";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: "EditVm",
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  emits: ['closed'],
  props: {
    currentItem: {
      required: true,
      type: Object
    },
    types: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      item: {},
      servers: [],
      ips: [],
      iso: [],
      ApiUrl: 'api/manager/vm/',
      loadTypesUrl: 'api/manager/vm-entities',
      loadServersUrl: 'api/manager/server/list?sort=Name',
      loadIPsUrl: '/api/manager/ip/list?sort=-DiscoveredAt',
      loadISOsUrl: '/api/launcher/content?parsed=y',
    }
  },
  methods: {
    clear() {
      this.item = {}
    },
    modalOpened() {
      this.loadServers()
      this.loadIps()
      this.genISOsSelectItems()
      this.loadVm()

    },
    closeModal() {
      this.$modal.hide('EditVm');
      this.$emit('closed')
    },
    loadVm() {
      let loader = this.$loading.show();
      axios.get(`${this.ApiUrl}/${this.currentItem.Id}`, this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.moveUp();
            this.loading = 'loaded';
            this.errorHandle(err, true, true, `VM: ${this.item.Name} error`);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.item = res.data.data;
            }
          })
    },
    loadServers() {
      let loader = this.$loading.show();
      axios.post(this.loadServersUrl, [], this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err, true, true);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.servers = res.data.data;
            }
          })
    },
    loadIps() {
      let loader = this.$loading.show();
      axios.post(this.loadIPsUrl, [], this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.ips = res.data.data;
            }
          })
    },
    loadTypes() {
      let loader = this.$loading.show();
      axios.get(this.loadTypesUrl, this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.types = res.data.data;
            }
          })
    },
    genISOsSelectItems() {
      this.iso = [];
      let loader = this.$loading.show();
      axios.post(this.loadISOsUrl,
          {
            "name": "isolist"
          },
          this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.moveUp();
            this.errorHandle(err);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            if (res.data.data !== undefined) {
              this.iso = res.data.data;
            }
          });
    },
    submitUpdate() {
      this.item.Cpu = Number(this.item.Cpu)
      this.item.Ram = Number(this.item.Ram)
      if (this.item.Cpu < 1 || this.item.Ram < 1 || isNaN(this.item.Cpu) || isNaN(this.item.Ram)) {
        alert("Cpu and Ram must be more than 0");
        return;
      }
      //
      // let current_hv = this.HyperVisors.find(hv => hv.Id === this.item.ServerId);
      // if ((parseInt(this.Ram) + parseInt(current_hv.VmSum)) > parseInt(current_hv.Ram)) {
      //   alert("Please check Ram value,  max available: " + (parseInt(current_hv.Ram) - parseInt(current_hv.VmSum)));
      //   //return; // stop form sending
      // }

      axios.patch(this.ApiUrl, this.item, this.authRespConf())
          .then(() => {
            this.$bvToast.toast('Successfully updated', {
              title: `VM: ${this.item.Name}`,
              autoHideDelay: 5000,
              variant: 'success',
              appendToast: true
            })
            this.closeModal()
          })
          .catch((err) => {
            this.errorHandle(err, true, true, `VM: ${this.item.Name} error`);
          });
    },
  },
  computed: {
    typeSelectItems() {
      return _.map(this.types, (type, index) => {
        return {
          value: parseInt(index),
          label: type
        }
      })
    },
    serversSelectItems() {
      return _.map(this.servers, (server) => {
        return {
          value: server.Id,
          label: server.Name
        }
      })
    },
    ipsSelectItems() {
      return _.map(this.ips, (ip) => {
        return {
          value: ip.Id,
          label: ip.Address
        }
      })
    },
    isoSelectItems() {
      return _.map(this.iso, (iso) => {
        return {
          value: iso.Id,
          label: iso.Address
        }
      })
    }
  }
}
</script>

<template>
  <div class="wrapper">
    <modal
        name="EditVm"
        :draggable="true"
        :resizable="true"
        :clickToClose="false"
        :width="850"
        :min-width="425"
        :min-height="500"
        :height="600"
        :scrollable="true"
        @closed="clear"
        @opened="modalOpened"
        class="modalBox"
        :style="{'--selectHeight': '120px'}"
    >
      <div class="window-header">
        Edit VM: {{ item.name }}. Current State:
        <span v-if="item.State === 'poweredOn'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">🟢</span>
        <span v-else-if="item.State === 'poweredOff'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">🔴</span>
        <span v-else-if="item.State === ''" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">0️⃣</span>
        <span v-else-if="item.State === 'UNKNOWN'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">🤷</span>
        <span v-else-if="item.State === 'DESTROYED'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">🚫 </span>
        <span v-else-if="item.State === 'NONE'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">⭕️ </span>
        <span v-else-if="item.State === 'suspended'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">⏸️</span>
        <span v-else-if="item.State === 'CREATED'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">🚀</span>
        <span v-else-if="item.State === 'CHANGED'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">⚠️</span>
        <span v-else-if="item.State === 'DELETED'" v-tippy="{arrow : true}"
              :title="`State: ${item.State}`">🗑️</span>
        <span v-else-if="item.State === 'ERROR'" v-tippy="{arrow : true}" title="Not found">❌</span>

        <a href="javascript:void(0)" class="close-modal pull-right" @click="closeModal()"><i
            class="fa fa-times"></i></a>
      </div>
      <div class="modal-body">
        <div class="page-modal" style="background: white;">
          <form class="form-horizontal">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Name</label>
                  <input
                      type="text"
                      :value="item.Name"
                      disabled
                      placeholder="Node name"
                      class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Server</label>
                  <v-select
                      :options="serversSelectItems"
                      label="label"
                      :disabled="item.State === 'poweredOn'"
                      :reduce="server => server.value"
                      v-model="item.ServerId"
                      placeholder="Select server.."
                      inputId="Server"/>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Type</label>
                  <v-select
                      :options="typeSelectItems"
                      label="label"
                      :reduce="entity => entity.value"
                      v-model="item.Entity"
                      placeholder="Select Type.."
                      inputId="Type"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Ip</label>
                  <v-select
                      :options="ipsSelectItems"
                      label="label"
                      :disabled="item.State === 'poweredOn'"
                      :reduce="ip => ip.value"
                      v-model="item.IpId"
                      placeholder="Select Type.."
                      inputId="Ip"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">MAC</label>
                  <input
                      type="text"
                      :disabled="item.State === 'poweredOn'"
                      v-model="item.Mac"
                      class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Ram</label>
                  <input
                      type="number"
                      v-model="item.Ram"
                      :disabled="item.State === 'poweredOn'"
                      min="4"
                      max="0"
                      class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">CPU</label>
                  <input
                      type="number"
                      v-model="item.Cpu"
                      :disabled="item.State === 'poweredOn'"
                      min="4"
                      max="0"
                      class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Comment</label>
                  <input
                      type="text"
                      v-model="item.Comment"
                      class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">DiscoveredAt</label>
                  <input
                      type="text"
                      disabled
                      :value="item.DiscoveredAt"
                      class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">ISO-image</label>
                  <v-select
                      :options="isoSelectItems"
                      v-model="item.VmIso"
                      :disabled="item.State === 'poweredOn'"
                      placeholder="Select ISO-image.."
                      inputId="ISO"/>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="submitUpdate()" class="btn btn-primary">Update VM</button>
        <button
            class="btn btn-default"
            href="javascript:void(0);"
            v-on:click="closeModal()"
            type="button"
        >
          <span>Cancel</span>
        </button>
      </div>
    </modal>
  </div>
</template>

<style scoped>

</style>